import React, { Fragment } from 'react';

import UI from '#front-credpago';

import * as S from './styles';

const Question = ({ id, title, name, options, value, handleChange, hasError }) => {
  return (
    <Fragment key={id}>
      <UI.Title
        level={3}
        fontWeight={700}
        label={title}
        style={{ textAlign: 'center', marginTop: 30, marginBottom: 15 }}
      />
      <S.WrapperRadios>
        <UI.Radio radios={options} value={value} onChange={(e) => handleChange(name, e.target.value)} />
      </S.WrapperRadios>

      {hasError && value === '' && <S.Error style={{ marginTop: 20 }}>Selecione uma opção.</S.Error>}
    </Fragment>
  );
};

Question.defaultProps = {
  id: 0,
  value: '',
  title: '',
  name: '',
  options: [],
  handleChange: () => {},
  hasError: false,
};

export default Question;
